import User from '../../User';

export default function victoryOutcome(run) {
  const limits = User.contentLimits(run.champion.model.key);
  const fullLimits = User.contentLimits(run.champion.model.key, true);
  if (run.storyEvent) {
    if (run.memory) return { kind: 'memory' };
    if (run.champion.level >= fullLimits.level)
      return { kind: 'complete' };
    if (limits.level < fullLimits.level && run.champion.maxLevel >= limits.level)
      return { kind: 'public' };
    return { kind: 'growth', level: User.dataFor(run.champion.model.key, run.difficultySetting).maxLevel };
  }
  const nilith = run.room?.celestial?.nilith;
  if (!nilith && run.floor < 4) return { kind: 'key' };
  return { kind: run.power < limits.mazePower ? 'power' : 'mazeLimit' };
}
